/* Blog posts live in blogPosts.json so the same data drives both the React
   pages and the build-time SEO prerender (scripts/prerender-blog.js).
   Posts are written in the language of their content (Hindi-first) and are
   shown as-is regardless of the site language toggle. Newest first. */

import posts from './blogPosts.json';

export const blogPosts = posts;

export const getBlogPost = (slug) => blogPosts.find((post) => post.slug === slug);
